import MagicClone from "../../../../physics/magic/MagicClone"
import ManaSource, { ManaSourceOptions } from "./ManaSource"

export type CloneManaSourceOptions = { clone: MagicClone } & ManaSourceOptions

export default class CloneManaSource extends ManaSource {

	clone

	constructor({ clone, ...rest }: CloneManaSourceOptions) {
		super(rest)

		this.clone = clone
		clone.manaSource = this
	}

	getCaster() {
		return this.clone
	}

}